"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.messages = void 0;

var _reactIntl = require("react-intl");

var messages = (0, _reactIntl.defineMessages)({
  searchForItems: {
    "id": "sb-select-option.searchForItems",
    "defaultMessage": "Search for items"
  },
  noItemsMatch: {
    "id": "sb-select-option.noItemsMatch",
    "defaultMessage": "No items found"
  },
  noOptions: {
    "id": "sb-select-option.noOptions",
    "defaultMessage": "No options available"
  },
  optionsSelected: {
    "id": "sb-select-option.optionsSelected",
    "defaultMessage": "{optionCount} {optionCount, plural, zero {options} one {option} other {options}} selected"
  }
});
exports.messages = messages;
//# sourceMappingURL=sb-general-i18n.js.map